const routes = {
    getCanidateList: '/payments/monthlyInvoices/candidates',
    CreateMonthlyInvoice: '/payments/monthlyInvoices/add',
    getMonthlyServiceInvoices: '/payments/monthlyInvoices',
    getInvoiceDetail: '/payments/monthlyInvoices/details',
    getPayments: '/payments',
    getInvoices:'/payments/invoices',
    getPaymentDetail: '/payments/details',
    updatePaymentStatus:'/payments/add',
    getVisaSales:'/reports/salesRevenue',
    getMonthlyBillings:'/reports/monthlyBilling'
  };
  
  export default routes